(() => {
  class countDownBlock extends HTMLElement {
    constructor() {
      super();
      try {
        const time = this.dataset.expired.split(",").map(Number);
        if (time.length > 3) {
          this.deadline = new Date(
            time[0],
            time[1],
            time[2],
            time[3],
            time[4] || 0,
            time[5] || 0
          ).getTime();
        } else {
          this.deadline = new Date(time[0], time[1], time[2]).getTime();
        }
      } catch (e) {
        console.error("Invalid date format:", e);
        return;
      }

      this.days = this.querySelector(".js-days");
      this.hours = this.querySelector(".js-hours");
      this.minutes = this.querySelector(".js-minutes");
      this.seconds = this.querySelector(".js-seconds");

      const now = this.getVancouverTime().getTime();

      if (this.deadline - now <= 0) {
        this.deadline += 24 * 60 * 60 * 1000; // Add 1 day
      }

      requestAnimationFrame(this.countDown.bind(this));
      this.classList.remove("disabled");
    }

    getVancouverTime() {
      const dateStr = new Date().toLocaleString("en-US", {
        timeZone: "America/Vancouver"
      });
      return new Date(dateStr);
    }

    pad(value) {
      return ("0" + Math.floor(value)).slice(-2);
    }

    countDown() {
      const now = this.getVancouverTime().getTime();
      const remain = this.deadline - now;

      if (remain < 1000) return;

      const days = this.pad(remain / (1000 * 60 * 60 * 24));
      const hours = this.pad((remain / (1000 * 60 * 60)) % 24);
      const minutes = this.pad((remain / (1000 * 60)) % 60);
      const seconds = this.pad((remain / 1000) % 60);

      this.render(this.days, days);
      this.render(this.hours, hours);
      this.render(this.minutes, minutes);
      this.render(this.seconds, seconds);

      this.days.setAttribute("data-count", days);
      this.hours.setAttribute("data-count", hours);
      this.minutes.setAttribute("data-count", minutes);
      this.seconds.setAttribute("data-count", seconds);

      requestAnimationFrame(this.countDown.bind(this));
    }

    render(el, value) {
      const arr = value.toString().split("");
      if (!el) return;

      if (el.childElementCount !== arr.length) {
        el.innerHTML = arr
          .map((item) => `<span>${item}</span>`)
          .join("");
      } else {
        arr.forEach((char, i) => {
          el.children[i].innerHTML = char;
        });
      }
    }
  }

  customElements.define("countdown-block", countDownBlock);
})();